<template>
    <div class="row">
        <div class="col-12 col-md-6">
            <form role="form">
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">Nazwa</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="cart.name">
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-2 col-form-label">plum</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="cart.plum">
                    </div>
                </div>
            </form>
            <div class="row">
                <div v-show="this.$route.params.id !== undefined" class="col-3">
                    <div class="btn btn-primary" @click.prevent="deleteShopppingCart()">
                        Usuń koszyk
                    </div>
                </div>
                <div class="col-9">
                    <div class="btn btn-primary" @click.prevent="saveShoppingCart()">
                        Zapisz
                    </div>
                </div>
            </div>
            <div class="hr-line-dashed"></div>
        </div>
        <p>{{cart}}</p>
    </div>
</template>

<script>
export default {
    name: 'ShopppingCartForm',
    data() {
        return {
            cart: {
                name: '',
                plum: ''
            }
        }
    },
    created() {
        this.$route.params.id !== undefined ?
        this.getData() :
        this.$emit( 'loading', false )
    },
    methods: {
        getData() {
            this.$emit( 'loading', true )
            this.$http.get( `vnfr/${this.$route.params.env}/shopping-cards/${this.$route.params.id}` )
                .then( resp => {
                    console.log ( resp, 'data' )
                    this.shop = resp.data.shopping_card
                    this.$emit( 'loading', false )
                } )
                .catch( err => {
                    this.$toastr.error( err )
                    this.$emit( 'loading', false )
                } )
        },
        deleteShop(){
           this.$emit( 'loading', true )
            this.$http.delete( `vnfr/${this.$route.params.env}/shopping-cards/${this.$route.params.id}` )
                .then( resp => {
                    console.log( 'deleted resp', resp )
                    this.$toastr.success( 'Usunięte!!' )
                    this.$emit( 'loading', false )
                } )
                .catch( err => {
                    this.$toastr.error( err )
                    this.$emit( 'loading', false )
                } )
        },
        saveShop(){
            this.$emit( 'loading', true )
            const url = `vnfr/${this.$route.params.env}/shopping-cards/${this.$route.params.id}`
            this.$http( {
                url: this.$route.params.id !== undefined ? url : 'vnfr/${this.$route.params.env}/shopping-cards/',
                method: this.$route.params.id !== undefined ? 'put' : 'post',
                data: this.shop
            } )
                .then( resp => {
                    console.log( resp )
                    this.$toastr.success( 'Zapisane!!' )
                    this.$emit( 'loading', false )
                } )
                .catch( err => {
                    this.$toastr.error( err )
                    this.$emit( 'loading', false )
                } )
        }
    }
}
</script>

<style scoped>
    .btn {
        min-width: 10vh;
        max-height: 4vh;
    }
    a {
        color:white;
    }
</style>
